// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spacer[data-v-d759b248]{flex-grow:1;height:1px;margin:0 20px -1px;opacity:.3;border-top-color:currentColor;border-top-width:2px}`, "",{"version":3,"sources":["webpack://./client/components/Spacer.vue"],"names":[],"mappings":"AAGA,yBACE,WAAA,CACA,UAAA,CACA,kBAAA,CACA,UAAA,CACA,6BAAA,CACA,oBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
